// Function to get selected names
export const getSelectedNames = (services, selectedServices) => {
    const selectedNames = [];

    // Iterate over the selected services
    selectedServices && Object.keys(selectedServices).forEach((parentId) => {
        const parentService = services.find((service) => service.id === parseInt(parentId));

        if (parentService) {
            Object.keys(selectedServices[parentId]).forEach((subServiceId) => {
                const subService = parentService.subServices.find(
                    (sub) => sub.id === parseInt(subServiceId)
                );

                if (subService) {
                    selectedServices[parentId][subServiceId].forEach((thirdLayerId) => {
                        const thirdLayerService = subService.subServices.find(
                            (thirdLayer) => thirdLayer.id === thirdLayerId
                        );
                        if (thirdLayerService) {
                            selectedNames.push(thirdLayerService.name); // Add the name to the array
                        }
                    });
                }
            });
        }
    });

    return selectedNames;
};